const DEBOUNCE_DELAY = 100;
const BREADCRUMBS_CONSTANTS = {
    AMOUNT_OF_DEFAULT_CHEVRONS: 2,
    CHEVRON_WIDTH: 24,
    ICON_WIDTH: 24,
    DEBOUNCE_DELAY,
    DROPDOWN_MENU_WIDTH: 300,
    DROPDOWN_TRIGGER_WIDTH: 21,
    ELLIPSIS: "…",
    HALF_OF_DEBOUNCE_DELAY: DEBOUNCE_DELAY / 2,
    LAST_CRUMB_ELLIPSIS_WIDTH: 60,
    BREADCRUMB_MAX_HEIGHT: 36,
    DEFAULT_BREAKPOINT_WIDTH: 201,
};
const CLASSES = {
    hidden: "breadcrumb-hidden",
    iconOnly: "breadcrumb-icon-only",
    isDropdown: "breadcrumb-dropdown",
    ellipsis: "breadcrumb-ellipsis",
};

export { BREADCRUMBS_CONSTANTS, CLASSES };
//# sourceMappingURL=index.js.map
